export function handleExitApp() {
    window.parent.postMessage({ type: 'tvremote', key: 'Escape' }, '*');
    if (window.UPshowAndroidApp && window.UPshowAndroidApp.closeApp) {
        window.UPshowAndroidApp.closeApp();
    }
}
